function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPressureDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2752",
    d: "M20.042 0H20a19.979 19.979 0 1 0 .042 0M20 37.5A17.5 17.5 0 1 1 37.5 20 17.5 17.5 0 0 1 20 37.5",
    style: {
      fill: "#ff7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2753",
    d: "M21.739 16.495c0-1.821-3.376-6.5-3.376-6.5s-3.376 4.684-3.376 6.5a3.378 3.378 0 0 0 6.752 0M19.863 15.4a.91.91 0 0 1 .857.834.857.857 0 1 1-.857-.834m9.225 11.822v1.25H7.638v-1.25H16.9V24.17a9.2 9.2 0 0 1-4.25-1.751l.75-1a8.064 8.064 0 1 0-3.231-6.456 8.029 8.029 0 0 0 .3 2.072l2.73-1.5L11.7 20.69l-5.155-1.5 2.8-1.537A9.3 9.3 0 1 1 19.4 24.195v3.029zM7.638 29.7h21.449v1.25H7.638z",
    transform: "translate(1.637 .162)",
    style: {
      fill: "#f5f5f5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureDrop);
export default __webpack_public_path__ + "static/media/pressure-drop.6a16426957f05ab8df0517539ada73a3.svg";
export { ForwardRef as ReactComponent };